import React, { useState } from 'react';
import SVG from 'react-inlinesvg';
import { Text, Link } from '@perch-labs/shrike';
import MegaphoneGraphic from '/images/advocacy/megaphone-dark.svg';
import { copyFor, routes } from 'config';
import { Card, Container, Grid, GridCell } from 'styles';
import { getSupportCopy } from './voice-support-card-waitlist.utils';
import {
  CloseButton,
  ButtonWrapper,
} from './voice-support-card-waitlist.style';

const getCopy = copyFor('solar.voiceSupportCard');

interface Props {
  state: string;
  utilityAccountId: number;
}

export const VoiceSupportCardWaitlist = (props: Props) => {
  const { state, utilityAccountId } = props;
  const { advocacy } = routes({ utilityAccountId });
  const copy = getSupportCopy({
    state,
  });
  const [isHidden, setIsHidden] = useState(false);
  const handleHideClick = () => {
    setIsHidden(true);
  };

  const image = <SVG src={MegaphoneGraphic} />;
  return !isHidden ? (
    <Card margin="0px" mobileVariant="flat">
      <Grid width="100%" gap="0">
        <GridCell
          columns={2}
          margin={{ top: '32px', left: '36px' }}
          padding={{ top: '12px' }}
        >
          <SVG src=""> {image}</SVG>
        </GridCell>
        <GridCell columns={10}>
          <ButtonWrapper>
            <CloseButton
              onClick={handleHideClick}
              icon="UIClose"
              aria-label="X"
            />
          </ButtonWrapper>
          <Card.Header>
            <Text textStyle="heading700" tag="h2">
              {copy.title}
            </Text>
          </Card.Header>
          <Card.Content>
            <Text>{copy.paragraph}</Text>
            <Container flex justifyContent="justified">
              <Link
                type="CTA"
                margin={{ top: '22px' }}
                to={advocacy}
                color="primaryInverse"
                size="small"
              >
                {getCopy('waitlistLink')}
              </Link>
            </Container>
          </Card.Content>
        </GridCell>
      </Grid>
    </Card>
  ) : null;
};
